import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useAuthenticationStore, { AuthenticationViews } from "./Store";
import { useConfiguration } from './Configuration';
import SetPassword from "./SetPassword";

const SetPasswordContainer: React.FC = () => {
  const { state, dispatch, finishJoin, isValidPassword, validatePasswordRequirements } = useAuthenticationStore()
  const { serverError, isLoading, emailOrPhone, rememberMe } = state
  const { configuration } = useConfiguration()
  const { productName } = configuration
  const navigate = useNavigate();

  const setEmailOrPhone = (newEmailOrPhone: string) => {
    dispatch({ type: 'SET_EMAIL_OR_PHONE', payload: newEmailOrPhone })
  }

  const setRememberMe = (newRememberMe: boolean) => {
    dispatch({ type: 'SET_REMEMBER_ME', payload: newRememberMe })
  }

  const joinPath = '../' + AuthenticationViews.join

  useEffect(() => {
    if (!emailOrPhone) {
      navigate(joinPath)
    }
  }, [emailOrPhone, navigate])

  return (
    <SetPassword
      serverError={serverError}
      isLoading={isLoading}
      emailOrPhone={emailOrPhone}
      rememberMe={rememberMe}
      productName={productName}
      finishJoin={finishJoin}
      isValidPassword={isValidPassword}
      validatePasswordRequirements={validatePasswordRequirements}
      setEmailOrPhone={setEmailOrPhone}
      setRememberMe={setRememberMe}
      notYouLink={joinPath}
    />
  )
}

export default SetPasswordContainer;